import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import api, { formatApiErrorDetail } from '../../lib/adminApi';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/api/auth/login', { email, password });
      localStorage.setItem('ido_admin_token', data.token);
      navigate('/admin');
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F7] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-light" style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}>I DO</h1>
          <p className="text-[10px] tracking-[0.3em] uppercase mt-1 text-[#757B7F]">Admin Dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white border border-[#E6E2DC]/60 p-8 space-y-5" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-sm text-[#2C2C2C] font-medium">
            <Lock size={14} className="text-[#DE92A9]" /> Sign in to manage your magazine
          </div>
          <div>
            <label className="block text-xs tracking-wider uppercase text-[#757B7F] mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border border-[#E6E2DC] px-4 py-2.5 text-sm focus:outline-none focus:border-[#DE92A9]"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-xs tracking-wider uppercase text-[#757B7F] mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border border-[#E6E2DC] px-4 py-2.5 text-sm focus:outline-none focus:border-[#DE92A9]"
              data-testid="admin-login-password"
            />
          </div>
          {error && <p className="text-xs text-red-600" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full text-white text-xs tracking-[0.15em] font-semibold py-3 transition-opacity hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: '#DE92A9' }}
            data-testid="admin-login-submit"
          >
            {loading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>
        </form>
      </div>
    </div>
  );
}
